"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeployStatus = exports.DeployConstant = void 0;
class DeployConstant {
    // deploy error type
    static DEPLOY_ERROR_TYPE = "DeployError";
    // deploy temp folder
    static DEPLOYMENT_TMP_FOLDER = ".deployment";
    // seconds to millisecond
    static MILLIS_SECONDS = 1000;
    // If mtime is valid and the two mtime is same in two-seconds, we think the two are same file.
    static ZIP_TIME_MS_GRANULARITY = 2 * DeployConstant.MILLIS_SECONDS;
    // Some files' mtime in node_modules are too old, which may be invalid,
    // so we arbitrarily add a limitation to update this kind of files.
    static LATEST_TRUST_MS_TIME = new Date(2000, 1, 1);
    // deploy zip file name
    static DEPLOYMENT_ZIP_CACHE_FILE = "deployment.zip";
    // call zip deploy api timeout
    static DEPLOY_TIMEOUT_IN_MS = 10 * 60 * 1000;
    // check deploy status timeout
    static DEPLOY_CHECK_RETRY_TIMES = 120; // Timeout: 20 min
    // check deploy status interval
    static BACKOFF_TIME_S = 10;
    // azure storage container name for static website
    static AZURE_STORAGE_CONTAINER_NAME = "$web";
    // days to millisecond
    static DAY_IN_MS = 1000 * 60 * 60 * 24;
    // The time at which the Azure storage shared access signature becomes valid.
    static SAS_TOKEN_LIFE_TIME_PADDING = DeployConstant.DAY_IN_MS;
    // The time at which the Azure storage shared access signature becomes invalid.
    static SAS_TOKEN_LIFE_TIME = DeployConstant.DAY_IN_MS * 3;
    // default index document for Azure storage static website
    static DEFAULT_INDEX_DOCUMENT = "index.html";
    // default error document for Azure storage static website
    static DEFAULT_ERROR_DOCUMENT = DeployConstant.DEFAULT_INDEX_DOCUMENT;
    // default deploy over time
    static DEPLOY_OVER_TIME = 1000 * 120;
    // default deploy retry times
    static DEPLOY_UPLOAD_RETRY_TIMES = 2;
}
exports.DeployConstant = DeployConstant;
var DeployStatus;
(function (DeployStatus) {
    DeployStatus[DeployStatus["Pending"] = 0] = "Pending";
    DeployStatus[DeployStatus["Building"] = 1] = "Building";
    DeployStatus[DeployStatus["Deploying"] = 2] = "Deploying";
    DeployStatus[DeployStatus["Failed"] = 3] = "Failed";
    DeployStatus[DeployStatus["Success"] = 4] = "Success";
})(DeployStatus || (exports.DeployStatus = DeployStatus = {}));
//# sourceMappingURL=deployConstant.js.map